import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, { FC } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { RequireAtLeastOne } from '../../types';
import FormContainer, { PreviousPage } from '../Shared/FormContainer/FormContainer';
import { ErrorMessage } from '../Shared/Shared';
import { FormTextInput, FormTextWrapper } from './styled';
import { FORM_TEXT_COMPONENT_TYPES } from './types';

interface FormTextProps {
  type?: keyof typeof FORM_TEXT_COMPONENT_TYPES;
  formOptions: UseFormReturn;
  onSubmit: (data: Record<string, string>) => void;
  children?: React.ReactNode;
  title?: string;
  placeholder?: string;
  loading?: boolean;
  error?: string;
  previousPage?: PreviousPage;
  Recaptcha?: FC;
  captchaError?: string;
  defaultValue?: string;
  componentItems?: { title: string; registerAs: string; requiredMessage?: string; pattern?: RegExp; patternMessage?: string; placeholder: string };
  number?: boolean;
  textArea?: boolean;
}

const FormText: FC<RequireAtLeastOne<FormTextProps, 'type' | 'componentItems'>> = ({
  type,
  formOptions,
  onSubmit,
  children,
  title,
  placeholder,
  loading,
  error,
  previousPage,
  Recaptcha,
  captchaError,
  defaultValue,
  componentItems,
  number = false,
  textArea = false
}) => {
  const { t } = useTranslation();
  const { register, handleSubmit, formState } = formOptions;
  const { title: defaultTitle, registerAs, requiredMessage, pattern, patternMessage, placeholder: defaultPlaceholder } = componentItems || FORM_TEXT_COMPONENT_TYPES[type!];

  return (
    <FormTextWrapper>
      <FormContainer title={t(title || defaultTitle)} loading={loading} previousPage={previousPage} error={!!formState.errors?.[registerAs] || !!captchaError} onSubmit={handleSubmit(onSubmit)}>
        <FormTextInput
          {...register(registerAs, {
            required: t(requiredMessage || 'formText.errorRequired'),
            pattern: {
              value: pattern || /.*/,
              message: t(patternMessage || 'formText.errorInvalidInput')
            }
          })}
          placeholder={placeholder || t(defaultPlaceholder)}
          autoFocus
          defaultValue={defaultValue}
          error={!!error}
          textArea={textArea}
          as={textArea ? 'textarea' : 'input'}
          type={number ? 'number' : 'text'}
        />

        {!!Recaptcha && Recaptcha}

        {!!formState.errors?.[registerAs] && <ErrorMessage>{formState?.errors?.[registerAs]?.message}</ErrorMessage>}
        {!!captchaError && <ErrorMessage>{captchaError}</ErrorMessage>}
      </FormContainer>
      {children}
    </FormTextWrapper>
  );
};
export default FormText;
